import { getConfigSync } from "@/lib/config";

/**
 * Returns the configured preview domain, falling back to the current hostname
 * in dev (where the app and previews share the same base domain).
 * Strips a leading "*." wildcard prefix if present.
 */
export function getPreviewDomain(): string {
  const configured = getConfigSync().previewDomain;
  if (configured) return configured.replace(/^\*\./, "");
  return window.location.hostname;
}

/**
 * Build the preview URL for a workspace asset file.
 *
 * The filePath stored in the DB is `{workspaceId}/path/to/file.html` (the
 * roomId is the leading segment). The preview domain is `{workspaceId}.{hostname}`,
 * so the workspaceId prefix is stripped from the path and re-emitted as the
 * subdomain.
 *
 * @param workspaceId - The workspace (chatroom) ID.
 * @param filePath - The file's virtual path, including the workspaceId prefix.
 * @param hostname - The base hostname (e.g. "grh.ngrok.io").
 * @returns The fully-qualified https preview URL.
 */
export function buildPreviewUrl(workspaceId: string, filePath: string, hostname: string): string {
  // 1. Strip the workspaceId prefix from filePath
  const prefix = `${workspaceId}/`;
  const relativePath = filePath.startsWith(prefix) ? filePath.slice(prefix.length) : filePath;

  // 2. Construct URL: https://{workspaceId}.{hostname}/{relativePath}
  return `https://${workspaceId}.${hostname}/${relativePath}`;
}
